import React from "react";
import { Accordion, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Loading } from "../../components";
import { ApiHelper, EnvironmentHelper, MessageHelper, MessageInterface, TemplateInterface } from "../../helpers";

interface Props {
  shape: string
}

export const NewMessageType: React.FC<Props> = props => {

  const [templates, setTemplates] = React.useState<TemplateInterface[]>(null);
  const [designerMessages, setDesignerMessages] = React.useState<MessageInterface[]>(null);
  const [yourDesignerMessages, setYourDesignerMessages] = React.useState<MessageInterface[]>(null);

  const init = () => {
    ApiHelper.get("/templates/available").then((data: TemplateInterface[]) => {
      const result: TemplateInterface[] = [];
      data.forEach(d => {
        if (d.templateType === "message" && d.shapes?.indexOf(props.shape) > -1) result.push(d);
      });
      setTemplates(result)
    });

    ApiHelper.get("/messages/public").then((data: MessageInterface[]) => {
      const result: MessageInterface[] = [];
      data.forEach(d => { if (d.shape === props.shape) result.push(d); });
      setDesignerMessages(result)
    });

    ApiHelper.get("/messages/yourDesigner").then((data: MessageInterface[]) => {
      const result: MessageInterface[] = [];
      data.forEach(d => { if (d.shape === props.shape) result.push(d); });
      setYourDesignerMessages(result)
    });
  }

  React.useEffect(init, [props.shape])

  const getAccordion = () => {
    const popularSection = getSection("popular", "Popular Message Templates", getPopular())
    const templateSection = (templates?.length > 4) ? getSection("templates", "All Message Templates", getTemplates()) : <></>;
    const designerSection = (designerMessages?.length > 0) ? getSection("designer", "Designer Templates", getDesigner()) : <></>;
    const yourDesignerSection = (yourDesignerMessages?.length > 0) ? getSection("yourDesigner", "Your Designer Messages", getYourDesigner()) : <></>;

    return (<Accordion id={"newMessage"} defaultActiveKey={"popular"} >
      {popularSection}
      {templateSection}
      {designerSection}
      {yourDesignerSection}
    </Accordion>)
  }

  const getSection = (eventKey: string, title: string, contents: JSX.Element) => {
    return (<Card>
      <Accordion.Toggle eventKey={eventKey}>{title}</Accordion.Toggle>
      <Accordion.Collapse eventKey={eventKey}>
        <Card.Body>{contents}</Card.Body>
      </Accordion.Collapse>
    </Card>)
  }

  const getPopular = () => {
    const result: JSX.Element[] = [];
    const thumbnailFile = (props.shape === "9:16") ? "thumbnailV.png" : "thumbnail.png";
    let i = 0;
    for (let t of templates) {
      if (i < 5) {
        result.push(<div key={"t" + t.id} className="col-6 col-md-3 col-xl-2">
          <Link to={"/messages/0?templateId=" + t.id + "&shape=" + props.shape}>
            <img src={EnvironmentHelper.ContentRoot + "/templates/" + t.id + "/" + thumbnailFile} alt="thumbnail" />
            <span>{t.name}</span>
          </Link>
        </div>);
      }
      i++;
    }
    return (<div id="templateList" className="row templateList condensed">{result}</div>);
  }

  const getTemplates = () => {
    const result: JSX.Element[] = [];
    const thumbnailFile = (props.shape === "9:16") ? "thumbnailV.png" : "thumbnail.png";
    templates.forEach(t => {
      result.push(<div className="col-6 col-md-3 col-xl-2">
        <Link to={"/messages/0?templateId=" + t.id + "&shape=" + props.shape}>
          <img src={EnvironmentHelper.ContentRoot + "/templates/" + t.id + "/" + thumbnailFile} alt="thumbnail" />
          <span>{t.name}</span>
        </Link>
      </div>);
    });
    return (<div id="templateList" className="row templateList condensed">{result}</div>);
  }

  const getDesigner = () => {
    const result: JSX.Element[] = [];
    designerMessages?.forEach(m => {
      const thumbPath = MessageHelper.getThumbnailPath(m);
      result.push(<div className="col-6 col-md-3 col-xl-2">
        <Link to={"/messages/0?templateId=" + m.templateId + "&shape=" + props.shape + "&copyFrom=" + m.id}>
          <img src={thumbPath} alt="thumbnail" />
          <span>{m.name}</span>
        </Link>
      </div>);
    });
    return (<div id="designerList" className="row condensed">{result}</div>);
  }

  const getYourDesigner = () => {
    const result: JSX.Element[] = [];
    yourDesignerMessages?.forEach(m => {
      const thumbPath = MessageHelper.getThumbnailPath(m);
      result.push(<div className="col-6 col-md-3 col-xl-2">
        <Link to={"/messages/0?templateId=" + m.templateId + "&shape=" + props.shape + "&copyFrom=" + m.id}>
          <img src={thumbPath} alt="thumbnail" />
          <span>{m.name}</span>
        </Link>
      </div>);
    });
    return (<div id="designerList" className="row condensed">{result}</div>);
  }

  if (templates === null) return <Loading />
  else return getAccordion();
};